export class ProgressBar {
    constructor(target) {
        this.element = $(target);

        this.classes = {
            fullscreenAdvertising: 'advertising--fullscreen',
        };

        this.progressBarElement = this.element.get(0);
        this.timerElement       = this.element.closest('.advertising').find('.advertising__progressbar-timer');
        this.lastSecond         = -1;
        this.duration           = this.element.data('timer') * 1000 || 15000;

        this.init();
    }


    init() {
        this.animateProgressBar();
    }

    animateProgressBar() {
        const frame = (time) => this.frame(time, this.duration);

        requestAnimationFrame(frame);
    }

    frame(time, duration, setStartTime = null) {
        const startTime   = setStartTime === null ? time : setStartTime;
        const timeElapsed = time - startTime;
        const progress    = Math.min(timeElapsed / this.duration, 1);

        this.progressBarElement.style.width = progress * 100 + '%';

        const remainingTime = Math.ceil((duration - timeElapsed) / 1000);

        if (remainingTime !== this.lastSecond) {
            this.timerElement.html(remainingTime);
            this.lastSecond = remainingTime;
        }

        if (timeElapsed < this.duration) {
            requestAnimationFrame((newTime) => this.frame(newTime, this.duration, startTime));
        }

        if (timeElapsed >= this.duration) {
            const closestTestElement = this.progressBarElement.closest(`.${this.classes.fullscreenAdvertising}`);

            if (closestTestElement) {
                closestTestElement.remove();
            }

            this.element.remove();

            this.timerElement.textContent = '0';
        }
    }
}
